module.exports = __webpack_public_path__ + "static/media/logoepar.a5118067.png";